'use client';

import NewsletterForm from './NewsletterForm';

interface FooterNewsletterWrapperProps {
  source?: string;
  variant?: 'light' | 'dark';
  size?: 'small' | 'medium' | 'large';
  showLabel?: boolean;
  placeholder?: string;
  buttonText?: string;
  className?: string;
}

export default function FooterNewsletterWrapper(props: FooterNewsletterWrapperProps) {
  return (
    <>
      {/* Newsletter form for unsubscribed users */}
      <div className="footer-newsletter-form">
        <NewsletterForm source="footer" {...props} />
      </div>
      
      {/* Subscribed message */}
      <div className="footer-newsletter-subscribed w-full lg:w-auto">
        <p className="font-ibm-plex-sans text-[#ffffff] text-[14px] opacity-70">
          ✓ Subscribed to newsletter
        </p>
      </div>
    </>
  );
}